import _extends from "@babel/runtime/helpers/extends";
import { optionsMap, GALLERY_CONSTS } from 'pro-gallery-lib';
import { migratePrivateControllers } from './controllers/private-controllers';
import { fullscreenFixedOptions } from './fullscreenFixedStyles';
const galleryFixedOptions = {
  [optionsMap.layoutParams.crop.enable]: false,
  [optionsMap.layoutParams.targetItemSize.unit]: 'SMART',
  [optionsMap.behaviourParams.item.secondaryMedia.trigger]: GALLERY_CONSTS.behaviourParams_item_secondaryMedia_trigger.HOVER
};
const optionsConverter = (options, shouldUseNewInfo, viewMode) => {
  let galleryOptions = _extends({}, options);
  // we need to differentiate berween fullscreen and gallery options
  let fullscreenOptions = _extends({}, options);
  if (options[optionsMap.behaviourParams.item.clickAction]) {
    const mapNativeItemClick = {
      MAGNIFY: 'MAGNIFY',
      LINK: 'LINK',
      NOTHING: 'NOTHING',
      EXPAND: 'ACTION',
      FULLSCREEN: 'ACTION',
      ACTION: 'ACTION'
    };
    const mapNativeFullscreenItemClick = {
      EXPAND: 'EXPAND',
      FULLSCREEN: 'FULLSCREEN'
    };
    galleryOptions[optionsMap.behaviourParams.item.clickAction] = mapNativeItemClick[options[optionsMap.behaviourParams.item.clickAction]] || 'NOTHING';
    fullscreenOptions[optionsMap.behaviourParams.item.clickAction] = mapNativeFullscreenItemClick[options[optionsMap.behaviourParams.item.clickAction]] || 'EXPAND';
  }
  if (options[optionsMap.layoutParams.crop.ratios]) {
    const ratios = [Number(options[optionsMap.layoutParams.crop.ratios])];
    galleryOptions[optionsMap.layoutParams.crop.ratios] = ratios;
  }
  galleryOptions = migratePrivateControllers(galleryOptions);
  fullscreenOptions = migratePrivateControllers(fullscreenOptions);
  if (shouldUseNewInfo) {
    galleryFixedOptions.EXPERIMENTALallowParallelInfos = true;
  } else if (GALLERY_CONSTS.isLayout('SLIDESHOW')(galleryOptions)) {
    galleryOptions[optionsMap.behaviourParams.item.overlay.hoveringBehaviour] = GALLERY_CONSTS.behaviourParams_item_overlay_hoveringBehaviour.NEVER_SHOW;
  }
  if (galleryOptions[optionsMap.behaviourParams.item.overlay.hoveringBehaviour] === 'NO_CHANGE') {
    galleryOptions[optionsMap.behaviourParams.item.overlay.hoveringBehaviour] = GALLERY_CONSTS.behaviourParams_item_overlay_hoveringBehaviour.ALWAYS_SHOW;
  }
  if (viewMode === 'EDIT' && galleryOptions[optionsMap.layoutParams.navigationArrows.position] === GALLERY_CONSTS.layoutParams_navigationArrows_position.MOUSE_CURSOR) {
    galleryOptions[optionsMap.layoutParams.navigationArrows.position] = GALLERY_CONSTS.layoutParams_navigationArrows_position.ON_GALLERY;
  }
  const result = _extends({}, galleryOptions, galleryFixedOptions);
  const fullscreenOverrides = Object.entries(fullscreenOptions).filter(_ref => {
    let option = _ref[0];
    return option.startsWith('controllers_fullscreen_');
  }).reduce((acc, _ref2) => {
    let option = _ref2[0],
      value = _ref2[1];
    const newOption = option.replace('controllers_fullscreen_', '');
    acc[newOption] = value;
    return acc;
  }, fullscreenFixedOptions);
  return {
    options: result,
    fullscreenOverrides
  };
};
export default optionsConverter;
//# sourceMappingURL=proGalleryOptionsBuilder.js.map